module.exports = __webpack_public_path__ + "6ad500707968bd41359289a0ed2b8396.pdf";